(() => {
  'use strict';
  if (window.masiPrivacyStarted) return;
  window.masiPrivacyStarted = true;
  const loaded = new Set();
  let scheduled = false, attempts = 0;
  function permissions() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return null;
    try {
      return {analytics: privacy.analyticsProcessingAllowed() === true,
        marketing: privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true,
        preferences: privacy.preferencesProcessingAllowed() === true};
    } catch (_) { return null; }
  }
  function load(name, url) {
    if (loaded.has(name)) return;
    loaded.add(name);
    if ([...document.scripts].some(script => script.src === url)) return;
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.dataset.masiPrivacy = name;
    document.head.append(script);
  }
  function apply() {
    scheduled = false;
    const allowed = permissions();
    if (!allowed) return;
    if (allowed.analytics) {
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('consentv2', {analytics_Storage: 'granted', ad_Storage: allowed.marketing ? 'granted' : 'denied'});
      load('analytics', 'https://www.clarity.ms/tag/jcldvn623w');
    }
    if (allowed.marketing && !loaded.has('marketing')) {
      window.twq = window.twq || function () { window.twq.exe ? window.twq.exe.apply(window.twq, arguments) : window.twq.queue.push(arguments); };
      window.twq.version = '1.1';
      window.twq.queue = window.twq.queue || [];
      window.twq('config', 'oizbl');
      load('marketing', 'https://static.ads-twitter.com/uwt.js');
    }
    if (allowed.preferences && document.querySelector('.trustpilot-widget')) {
      load('preferences', 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if ('requestIdleCallback' in window) window.requestIdleCallback(apply, {timeout: 3000});
    else setTimeout(apply, 200);
  }
  function consentChanged() {
    const allowed = permissions();
    if (!allowed) return;
    if (loaded.has('analytics')) window.clarity?.('consentv2', {
      analytics_Storage: allowed.analytics ? 'granted' : 'denied',
      ad_Storage: allowed.marketing ? 'granted' : 'denied'
    });
    // Reload ends scripts that have no reliable runtime opt-out. The cart is server-side.
    if ([...loaded].some(purpose => !allowed[purpose])) {
      const form = document.getElementById('purchase');
      if (form?.dataset.ready) {
        const url = new URL(location.href);
        url.searchParams.set('plan', document.getElementById('one-time').checked ? 'one-time' : 'subscribe');
        url.searchParams.set('qty', document.getElementById('purchase-quantity').value);
        history.replaceState(history.state, '', url);
      }
      location.reload();
      return;
    }
    schedule();
  }
  function start() {
    if (permissions()) { schedule(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (!error) schedule();
      });
    } else if (++attempts < 20) setTimeout(start, 250);
  }
  document.addEventListener('visitorConsentCollected', consentChanged);
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, {once: true});
})();
